'use client'

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useAtom } from 'jotai';
import { useState } from "react";

// lib files
import { ORIGIN_STRING } from "@/lib/constants";
import { clearLocalProfile } from "@/lib/helpers/handle-sign-out";
import { passportTransferMembershipAtom } from '@/lib/atoms/passport-transfer';
import { setRedirectCookie } from "@/lib/helpers/utils";
import { useHasMounted } from "@/lib/hooks";

// components
import LinkButton from '@/components/Button/LinkButton';
import PassportTransferFAQ from '@/components/passport/PassportTransferFAQ/PassportTransferFAQ';

// constants
import { PASSPORT_TRANSFER_ONE_MEMBERSHIP } from '@/components/passport/PassportTransferFAQ/PassportTransferFAQContent';

// styles
import styles from './PassportTransferMultipleMemberships.module.scss';

// types
import { PassportTransferMembership, PassportTransferMembershipWithEmail } from '@/lib/types/passportTransferMembership';
import { isEmpty } from '@/lib/helpers/empty';
interface PassportTransferMultipleMembershipsProps {
  memberships: PassportTransferMembership[];
  email: string;
}

export default function PassportTransferMultipleMemberships(props: PassportTransferMultipleMembershipsProps) {
  const { memberships, email } = props;
  const hasMounted = useHasMounted();
  const [selectedMembership, setSelectedMembership ] = useState<PassportTransferMembership | null>(null)
  const [ _, setPassportTransferMembership ] = useAtom(passportTransferMembershipAtom);

  if (!hasMounted) {
    return null;
  }

  const hostname = isEmpty(ORIGIN_STRING) ? `https://${window.location.host}` : ORIGIN_STRING
  const passportTransferSignIntoNewAccountURL = `${hostname}/passport/transfer/sign-into-new-account/`;
  const passportTransferActivateMembershipURL = `${hostname}/passport/transfer/activate-membership/`;

  const setMembershipObjectInSessionStorage = () => {
    if (!selectedMembership) return;
    const selectedMembershipWithEmail: PassportTransferMembershipWithEmail = {
      ...selectedMembership,
      membership_transfer_from_email: email
    };
    setPassportTransferMembership(selectedMembershipWithEmail);
  }

  return (
    <div className={styles.passport_transfer_multiple_memberships} data-sentry-component="PassportTransferMultipleMemberships" data-sentry-source-file="PassportTransferMultipleMemberships.tsx">
      <h1>Transfer Your Passport Benefit to a Different Email</h1>
      <p className={styles.passport_transfer_multiple_memberships__description}>
        You will use this login to access Passport shows and films moving forward.
      </p>
      <div className={styles.passport_transfer_multiple_memberships__membership_wrapper}>
        <div className={styles.passport_transfer_multiple_memberships__membership_content}>
          <p>
            Please select the Passport benefit you’d like to transfer. You may only transfer one Passport benefit at a time, but you may repeat this process any number of times.
          </p>

          {memberships.map((membership, i) => {
            const stationId = membership.station_id;
            const shortCommonName = membership.station_data?.attributes.short_common_name || stationId;
            const membershipId = `membership-${stationId}`;
            let checked = false;

            if (selectedMembership?.station_id === stationId) {
              checked = true
            }

            return (
              <div className={styles.passport_transfer_multiple_memberships__membership_selection_radio} key={i}>
                <input
                  id={membershipId}
                  type='radio'
                  name='membership'
                  value={shortCommonName}
                  aria-checked={checked}
                  checked={checked}
                  onChange={() => {setSelectedMembership(membership)}}
                />
                <label
                  className={styles.radio_label}
                  htmlFor={membershipId}
                >
                  {shortCommonName}
                </label>
              </div>
          )})}
        </div>
      </div>
      <div className={styles.passport_transfer_multiple_memberships__buttons}>
        <LinkButton
          href={`${ORIGIN_STRING}/sso/logout?redirect=${passportTransferSignIntoNewAccountURL}`}
          style='white' wrapperComponent='a'
          disabled={selectedMembership === null}
          onClick={() => {
            setMembershipObjectInSessionStorage()
            clearLocalProfile()
          }}
        data-sentry-element="LinkButton" data-sentry-source-file="PassportTransferMultipleMemberships.tsx">
          Sign In
        </LinkButton>
        <LinkButton
          href={`${ORIGIN_STRING}/sso/logout?redirect=${hostname}/sso/register?activation=true`}
          style='blue'
          onClick={() => {
            setRedirectCookie(passportTransferActivateMembershipURL)
            setMembershipObjectInSessionStorage()
            clearLocalProfile()
          }}
          wrapperComponent='a'
          disabled={selectedMembership === null}
        data-sentry-element="LinkButton" data-sentry-source-file="PassportTransferMultipleMemberships.tsx">
          Create an Account
        </LinkButton>
      </div>
      <PassportTransferFAQ faqBank={PASSPORT_TRANSFER_ONE_MEMBERSHIP} data-sentry-element="PassportTransferFAQ" data-sentry-source-file="PassportTransferMultipleMemberships.tsx" />
    </div>
  )
}
